import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'
import {
  DocumentTemplateDetailsDocument,
  DocumentTemplateDetailsQuery,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { DocumentTemplate as NullableDocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplate'

import VerticalSeparator from './VerticalSeparator'
import WorkflowsTag from './WorkflowsTag'

type DocumentTemplate = NonNullable<NullableDocumentTemplate>
type TaskConfigurationSendDocumentTemplate =
  DocumentTemplateDetailsQuery['processes']['taskConfigurationSendDocumentTemplatesConnection']['nodes'][number]

interface Props {
  documentTemplate: DocumentTemplate
  taskConfigurations?: TaskConfigurationSendDocumentTemplate[]
}

function Tags({ documentTemplate, taskConfigurations }: Props) {
  const isFillable = documentTemplate.fillable
  const hasVariables = !!documentTemplate.values?.length
  const hasTaskConfigurations = !!taskConfigurations?.length
  const hasTags = isFillable || hasVariables || hasTaskConfigurations

  if (!hasTags) return null

  return (
    <Box flexDirection="row" gap="s8">
      <WorkflowsTag taskConfigurations={taskConfigurations} />

      {hasTaskConfigurations && <VerticalSeparator />}

      {isFillable && (
        <Tag type={Tag.Types.champagne} capitalize>
          {i18n.t('documents.document_templates.tags.fillable')}
        </Tag>
      )}

      {hasVariables && (
        <Tag type={Tag.Types.malibu} capitalize>
          {i18n.t('documents.document_templates.tags.variables')}
        </Tag>
      )}
    </Box>
  )
}

export default Tags
